module.exports = __webpack_public_path__ + "media/images/athletes/3418-df5246caaabbdf7d3f34fca13cc77f4a.png";